import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes } from '../utilities'
import '../data-viz/components/MetricBreakdown'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "chats",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "calls",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "emails",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { chats, calls, emails, theme, helpText } = config
    const chatsVal = (Object.keys(sigmaData).length && chats) ? sigmaData[chats][0] : null
    const callsVal = (Object.keys(sigmaData).length && calls) ? sigmaData[calls][0] : null
    const emailsVal = (Object.keys(sigmaData).length && emails) ? sigmaData[emails][0] : null
    const values = [chatsVal,callsVal,emailsVal]

    return (
        <>
        <zero-metric-breakdown
            data-fill={themes[theme]?.dark}
            data-bg={themes[theme]?.light}
            data-heading="PHA Interactions"
            data-format="decimal"
            data-values={values.join(',')}
            data-labels="Chats,Calls,Emails"
            data-help={helpText}></zero-metric-breakdown>
        </>
    )
}
